/* eslint-disable no-param-reassign */
import { useRef, useEffect, CSSProperties } from 'react';
import ReactInputMask, { Props as InputProps } from 'react-input-mask';
import { useField } from '@unform/core';
import * as S from './styles';

type Props = InputProps & {
  label: string;
  helperText?: string;
  name: string;
  containerStyle?: CSSProperties;
};

export default function InputMask({
  label,
  helperText,
  name,
  containerStyle,
  ...rest
}: Props) {
  const inputRef = useRef(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
      setValue(ref: any, value: string) {
        ref.value = value;
      },
      clearValue(ref: any) {
        ref.value = '';
      },
    });
  }, [fieldName, registerField]);

  return (
    <S.Container style={containerStyle} hasError={!!error}>
      <label htmlFor={name}>{label}</label>
      <ReactInputMask
        ref={inputRef}
        name={name}
        id={name}
        defaultValue={defaultValue}
        {...rest}
      />
      {error && <S.Error>{error}</S.Error>}
      {helperText && <S.HelperText>{helperText}</S.HelperText>}
    </S.Container>
  );
}

InputMask.defaultProps = {
  helperText: '',
  containerStyle: {},
};
